import { React, useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../admin/shared/table';
import LoaderComponent from '../../admin/shared/loader';
import { API_URL, PAGE_ROUTE } from '../shared/constant';

export default function SliderListComponent() {

    let columns = [{
        field: 'title',
        lable: 'Title'
    }, {
        field: 'sub_title',
        lable: 'Sub Title'
    },
    {
        field: 'image',
        lable: 'Image'
    },
    {
        field: 'link',
        lable: 'Link'
    },
    ];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    useEffect(() => {
        getSlider();
    }, []);

    useEffect(() => {
        isRecall && getSlider();
    }, [isRecall]);

    const getSlider = () => {
        setLoading(true);
        axios.post(API_URL.ADMIN_SLIDER_LIST, {}).then(res => {
            setData(res.data.data);
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    }

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_SLIDER_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    }

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_SLIDER_EDIT + item.id, { replace: true });
    }


    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Slider
                        <NavLink to={PAGE_ROUTE.ADMIN_SLIDER_CREATE} className="btn btn-primary">
                            Add
                        </NavLink>
                    </h4>
                    {
                        isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    columns={columns}
                                    data={data}
                                    onDelete={onDelete}
                                    onEdit={onEdit}>
                                </TableComponent>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
